import React, { useEffect } from "react";
import { useNavigate } from "react-router";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import { AuthHeader } from "@/components/authentication/common/AuthHeader";
export const VerificationSentPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/");
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <section className="auth-page">
      <div className="flex flex-col justify-center items-center min-h-full px-6 py-12 lg:px-8">
        <div className="w-full sm:max-w-sm flex flex-col gap-8">
          <AuthHeader
            title="Verification Sent"
            icon={
              <EmailOutlinedIcon
                style={{ fontSize: 64, color: "var(--color-fg)" }}
              />
            }
          />

          <div className="flex flex-col gap-4 text-center">
            <p className="text-fg-muted-medium">
              We have sent a verification email to your inbox. Please check your
              email and verify your account.
            </p>
            <p className="text-fg-medium">
              Redirecting to login in a few seconds...
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
